import { ICheckboxOption } from "./CheckboxGroup";

export const normalizeOption = (
  option: string | ICheckboxOption,
): ICheckboxOption => {
  if (typeof option === "string") {
    return {
      label: option,
      value: option.replaceAll(" ", "-").toLocaleLowerCase(),
    };
  }
  return {
    ...option,
    value:
      option.value || option.label.replaceAll(" ", "-").toLocaleLowerCase(),
  };
};
